<template>
    <v-card class="elevation-1 rounded-4"> 
        <v-toolbar flat height="45px">
            <span class="font-weight-bold" v-if="title">{{ title }}</span>
            <span class="font-weight-bold" v-else>Information</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="text-xs-center">
            <p v-html="msg" class="mt-10"></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn title="Ok" class="primary" dark @click="ok" :loading="loading">Ok</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>

export default {
    data () {
        return {
            loading: false,
        }
    },
    props:['title','msg'],
    methods: {
        ok() {
            this.closeDialog()
            this.$emit('ok', null)
        },
        closeDialog() {
            this.$emit('update:dialogOkOnly', false)
        }
    },
}
</script>